import { Notifications } from './types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getNotificationSettingsThunk, getEditNotificationSettingsThunk, updateNotificationSettingsThunk } from './thunks';
import { ServerError } from '../../models/errors'
import { WEEKS_ARRAY } from '../../models/notifications';
import { convertToLocalTime } from 'date-fns-timezone'
import { format, getUnixTime, parseISO, addDays,subDays } from 'date-fns'


const initialState: Notifications = {
    settings:[],
    settingType: [],
    editNotificationSetting: {
        id: 0,
        name: '',
        type_id: 0,
        timeframe_type_id: 0,
        notify_timeframe: [],
        alias_name:'',
        status: 0
    },
    notificationId:0,
    inProgress:false,
    error:null
}

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setNotificationIdAction: (state, action) => {
            state.notificationId = action.payload
        },
        updateNotificationDataAction: (state,action)=>{
            const settings = state.settings
            const index = state.settings.findIndex(v=>v.id === action.payload.id)
            settings[index] = action.payload;
            state.settings = settings;
        }
    },
    extraReducers: (builder) => {
        //get notification
        builder.addCase(getNotificationSettingsThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(getNotificationSettingsThunk.fulfilled, (state, action) => {
            state.settings =  action.payload.data
            state.inProgress = false
            state.error = null
        })
        builder.addCase(getNotificationSettingsThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload as ServerError
        })
        // get Edit notification setting
        builder.addCase(getEditNotificationSettingsThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(getEditNotificationSettingsThunk.fulfilled, (state, action) => {
            state.inProgress = false
            const {timeframe_types, id,notify_timeframe,status,timeframe_type_id,type_id,name} = action.payload.data
            state.settingType = action.payload.data.timeframe_types
            const intervalSetting:any = [];
            notify_timeframe.forEach((v:any)=>{
                const timezone:string = Intl.DateTimeFormat().resolvedOptions().timeZone
                const localTimeSchedule = format(convertToLocalTime(new Date(Number(v.timestamp * 1000)), { timeZone: timezone }),'EEEE HH:mm:ss').split(' ');
                const scheduled_day :any= localTimeSchedule[0]
                const scheduled_time:any =  localTimeSchedule[1]
                if(!Array.isArray(intervalSetting[WEEKS_ARRAY[scheduled_day]])){
                  intervalSetting[WEEKS_ARRAY[scheduled_day]] = [];
                  intervalSetting[WEEKS_ARRAY[scheduled_day]].push({id:v.id,scheduled_time:scheduled_time});
                }else{
                  intervalSetting[WEEKS_ARRAY[scheduled_day]].push({id:v.id,scheduled_time:scheduled_time});
                }
              })
            state.editNotificationSetting = { id,notify_timeframe:intervalSetting,status,timeframe_type_id,type_id, name}
            state.error = null
        })
        builder.addCase(getEditNotificationSettingsThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload as ServerError
        })

        // update notification setting
        builder.addCase(updateNotificationSettingsThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(updateNotificationSettingsThunk.fulfilled, (state, action) => {
            state.inProgress = false
            const {notify_timeframe,status,timeframe_type_id} = action.payload.data
            const intervalSetting:any = [];
            notify_timeframe.forEach((v:any)=>{
                const timezone:string = Intl.DateTimeFormat().resolvedOptions().timeZone
                const localTimeSchedule = format(convertToLocalTime(new Date(Number(v.timestamp * 1000)), { timeZone: timezone }),'EEEE HH:mm:ss').split(' ');
                const scheduled_day :any= localTimeSchedule[0]
                const scheduled_time:any =  localTimeSchedule[1]
                if(!Array.isArray(intervalSetting[WEEKS_ARRAY[scheduled_day]])){
                    intervalSetting[WEEKS_ARRAY[scheduled_day]] = [];
                    intervalSetting[WEEKS_ARRAY[scheduled_day]].push({id:v.id,scheduled_time:scheduled_time});
                }else{
                    intervalSetting[WEEKS_ARRAY[scheduled_day]].push({id:v.id,scheduled_time:scheduled_time});
                }
              })
            state.editNotificationSetting = { ...state.editNotificationSetting,notify_timeframe:intervalSetting,timeframe_type_id}
            state.error = null
        })
        builder.addCase(updateNotificationSettingsThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload as ServerError
        })
    }
})

export const { 
    setNotificationIdAction,
    updateNotificationDataAction
} = notificationSlice.actions

export default notificationSlice.reducer